import { Component, Input, OnInit } from '@angular/core';
import { SharedHttpService } from './../../services/shared-http.service';

@Component({
  selector: 'app-case-log-history',
  templateUrl: './case-log-history.component.html',
  styleUrls: ['./case-log-history.component.scss']
})
export class CaseLogHistoryComponent implements OnInit {
  @Input() eCaseId:any; 
  logHistoryArr:any=[];
  constructor(private sharedService:SharedHttpService) { }

  ngOnInit(): void {
    this.sharedService.get(`api/Case/GetCaseLog?eCaseId=${this.eCaseId}`).subscribe(res=>{
      this.logHistoryArr=res;
    })
  }

}
